import React from "react";
import LoginForm from "./components/loginForm";
import VersionApp from "./components/VersionApp";
import "./styles/loginForm.css";

function App() {
  return (
    <div className="App">
      <LoginForm />
      <VersionApp />
    </div>
  );
}

export default App;
